import { DepenseParPoste } from './bilanEnergieService';
import * as storageService from '../localStorageService';

export const DUREE_PROJETCTION_FINANCIERE = 25;

export type Indexations = {
    generale: number;
    bois: number;
    electricite: number;
    fioul: number;
    gaz: number;
    electricite_revente: number;
    electricite_autoconsomation: number;
};

/**
 * cacul de l'économie sur le nombre d'année, en tenant compte d'une indexation générale (commune) des prix des différentes énergies.
 * @param depenseInitiale la dépense d'énergie annuelle initiale avant travaux
 * @param depenseFinale la dépense d'énergie annuelle finale, après travaux.
 * @param durationYear le nombre d'année
 * @returns le gain sur le nombre d'année tenant compte de l'indexation du prix des énergies.
 */
export const calculEconomie_IndexationSimple = (
    depenseInitiale: DepenseParPoste,
    depenseFinale: DepenseParPoste,
    durationYear = DUREE_PROJETCTION_FINANCIERE
): number => {
    // Algorithme :
    // on calcule l'économie de la première année (variable Year0)
    // on calcule ensuite par augmentation géométrique, l'économie chaque année.
    // on cumule ces économies chaque année, dans la variable cumul.
    const indexations = storageService.getConfig('indexations');
    // voici l'algo :
    let Year0 = depenseInitiale.prix() - depenseFinale.prix();
    let cumul = 0;
    for (let i = 0; i < durationYear; i++) {
        cumul += Year0 * Math.pow(indexations.generale, i);
    }
    return cumul;
};
